import React, { FC } from 'react'
import { makeStyles } from 'transfix-ui/core'
import { RequirementsFilledIcon, RequirementsIcon } from 'transfix-icons'

interface INotificationsBadge {
  /**
   * Number of issues past sla
   * @default 0
   */
  issuesCount: number
  hover: boolean
}

const useNotificationBadgeStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(0.5),
    '& > svg': {
      padding: '1px',
    },
  },
  icon: {
    width: '20px',
    height: '20px',
  },
  filled: {
    paddingTop: '2px',
    paddingLeft: '3px',
  },
}))

const NotificationsBadge: FC<INotificationsBadge> = ({ hover, issuesCount = 0 }) => {
  const classes = useNotificationBadgeStyles()

  return (
    <div className={classes.root}>
      {hover ? (
        <div className={`${classes.filled} ${classes.icon}`}>
          <RequirementsFilledIcon color='warning1' size='medium' />
        </div>
      ) : (
        <div className={classes.icon}>
          <RequirementsIcon color={issuesCount > 0 ? 'warning1' : 'inherit'} size='medium' />
        </div>
      )}
    </div>
  )
}

export default NotificationsBadge
